export const DEFAULT_MAP_PADDING_METERS = 400;
